import React from "react";
import {
  List,
  ListItem,
  ListItemButton,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";
import { RxSeriesDto } from "../../../../api-client";
import { mobiliTheme } from "../../../../themes/mobiliTheme";
import { usePatientRxSeries, useRxSeries } from "../../../../stores/Rx/rx.queries";
import { observer } from "mobx-react";
import useStore from "../../../../helpers/useStore";
import { PatientsContext } from "../../../../stores/Patients/patients.provider";
import { PatientCommands } from "../../../../stores/Patients/patient.commands";
import { therapyRxTermLabel } from "../../../../helpers/therapyRxLabel";

const RxSeriesSelector = observer(() => {
  const patientsStore = useStore(PatientsContext);
  const { selectedSeriesId } = patientsStore;
  const patientId = patientsStore.selectedPatientId;

  const {
    data: seriesData = [],
    isLoading,
    error 
  } = usePatientRxSeries(patientId || 0);
  
  const { selectSeries } = PatientCommands(patientsStore);

  const handleSeriesClick = (series: RxSeriesDto) => {
    selectSeries(series.id!);
  };

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error || seriesData.length === 0) {
    return <Typography>Keine Serien gefunden</Typography>;
  }
  return (
    <List component="nav" aria-label="therapy list">
      {seriesData.map((series, index) => (
        <ListItem key={index} sx={{ padding: "4px 0px", width: "100%" }}>
          <ListItemButton
              onClick={() => handleSeriesClick(series)}
            selected={selectedSeriesId === series.id}
            sx={{ padding: "0px" }}
          >
            <Paper
              sx={{
                padding: "8px",
                display: "flex",
                flex: "1",
                alignItems: "center",
                backgroundColor:
                  selectedSeriesId === series.id
                    ? "secondary.light"
                    : mobiliTheme.lowLevelContainerBackground,
                boxShadow: 3,
              }}
            >
              <Typography sx={{ flexShrink: 0 }}>{series.label}</Typography>

              <Typography
                variant="body2"
                sx={{ marginLeft: "8px", padding: "0px 4px", color: "text.secondary" }}
              >
                {series.therapyRxs?.map((therapy: any, i: number) => (
                  <React.Fragment key={therapy.id ?? i}>
                    {i > 0 && <span style={{ margin: "0 4px" }}>·</span>}
                    <span style={{ fontSize: "0.75em" }}>{therapy.rx.rxNumber} </span>
                    <span style={{ color: "inherit", fontWeight: 600 }}>
                      {therapy.amount}×{therapyRxTermLabel(therapy)}
                    </span>
                  </React.Fragment>
                ))}
              </Typography>
            </Paper>
          </ListItemButton>
        </ListItem>
      ))}

      
    </List>
  );
});

export default RxSeriesSelector;
